import { Container, Image } from 'react-bootstrap'
import { FaRegClock, FaAngleDoubleLeft } from 'react-icons/fa'
import styles from './item.module.css'
import Link from 'next/link'

const ModuleItem = (props) => (
    <Container className="my-5 py-5 d-flex justify-content-center">
       <div>
            <div className={`d-flex border-left align-items-start ${styles.timelineBorder}`}>
                <span className="py-md-3 py-1 px-md-4 px-2 h4 bg-green text-white position-relative spanNum">{props.module}</span>
                <div className="module-heading">
                    <h5><strong>{props.title}</strong></h5>
                    <p>{props.subtitle}</p>
                    <p className="mb-5"><FaRegClock className="text-green h5 mb-0 mr-3"/> You can complete this module in: {props.cduration} mins</p>
                </div>
            </div>
                
            {props.children}

            <div className="pl-3 d-sm-flex align-items-start footerarrow">
                <Image src="../../images/learnandearn/arrow.svg" className="arrow"/>
                <div className="btngo ml-3">
                    { props.gotoLink ? 
                        (
                            props.gotoLink.includes("//") ?
                            <a href={props.gotoLink} className="border border-green font-weight-bold text-green py-3 px-4 btnback h7 text-decoration-none btn-trans-green">{props.gotoIcon} {props.goto}</a>
                            :
                            <Link href={props.gotoLink}><a className="border border-green font-weight-bold text-green py-3 px-4 btnback h7 text-decoration-none btn-trans-green">{props.gotoIcon} {props.goto}</a></Link> 
                        )
                    : null }
                    <p className="mb-0 mt-4 footertext h7">{props.footer}</p>
                    <Link href="/learn-and-earn/modules"><a className="d-block mt-5 h7 text-green"><FaAngleDoubleLeft/> Back to Modules</a></Link>
                </div>
                <Image src={props.imgbtm} className="ml-sm-5 mt-n4 d-md-flex d-none" width={100}/>
            </div>
            
            <style jsx global>{`
                .spanNum{
                    left: -2rem;
                }
                .btngo{
                    margin-top: -1rem;
                }
                .btnback{
                    border-width:2px!important;
                }
                
                .timelineCircle{
                   
                    top: 2rem;
                    padding: .5rem;
                    left: -.8rem;
                    border-color:#43a649!important;
                    border-width:4px!important
                }
                .timelineBorder{
                    border-color:black!important;
                    border-width:2px!important
                }
                .arrow{
                    width: 5rem;
                    margin-left: -1rem;
                    margin-top: -.5rem;
                }
                .footertext{
                    max-width:350px;
                }
                @media(max-width:767px){
                    .footerarrow{
                        margin-top: -.8rem;
                    }
                    .btnback{
                        position: relative;
                        left: 3.5rem;
                        top: -1rem;
                    }
                    .spanNum {
                        left: -.9rem;
                    }
                }
            `}</style>
           
       </div>
    </Container>
  
);
export default ModuleItem